<mat-card appearance="outlined">
  <div class="title-container">
    <mat-form-field>
      <mat-label>{{'general.title' | translate}}</mat-label>
      <input [(ngModel)]="dynamicContent.title" matInput required/>
    </mat-form-field>
  </div>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>{{'dynamicContent.question' | translate}}</mat-label>
      <textarea formControlName="textContent" matInput required></textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{'dynamicContent.type' | translate}}</mat-label>
      <mat-select formControlName="type" required>
        <mat-option *ngFor="let type of types" [value]="type">{{ 'dynamicContent.' + type | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" *ngIf="form.get('type').value && form.get('type').value !== 'scale'">
      <mat-label>{{ 'dynamicContent.answers' | translate }}</mat-label>
      <mat-chip-grid #chipList>
        <mat-chip-row *ngFor="let answer of answers" (removed)="remove(answer)">
          {{ answer }}<button matChipRemove><mat-icon>cancel</mat-icon></button>
        </mat-chip-row>
        <input [placeholder]="'dynamicContent.votingNewAnswer' | translate" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
               [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" [matChipInputFor]="chipList">
      </mat-chip-grid>
    </mat-form-field>
    <ng-container *ngIf="form.get('type').value && form.get('type').value === 'scale'">
      <div class="scale-fields">
        <mat-form-field>
          <mat-label>{{'dynamicContent.scaleIcon' | translate}}</mat-label>
          <mat-select formControlName="scaleIcon" required>
            <mat-option *ngFor="let type of scaleIconType" [value]="type">{{ 'dynamicContent.' + type | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'dynamicContent.scaleMin' | translate}}</mat-label>
          <input formControlName="scaleMin" matInput required>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'dynamicContent.scaleMax' | translate}}</mat-label>
          <input formControlName="scaleMax" matInput required>
        </mat-form-field>
        <mat-form-field *ngIf="form.get('scaleIcon').value && form.get('scaleIcon').value === 'numeric'">
          <mat-label>{{'dynamicContent.scaleStep' | translate}}</mat-label>
          <input formControlName="scaleStep" matInput required>
        </mat-form-field>
      </div>
    </ng-container>
    <div class="footer">
      <ibex-checkbox [title]="'dynamicContent.showIntermediateResult' | translate" [checked]="dynamicContent.content.showIntermediateResult"
                     (click)="dynamicContent.content.showIntermediateResult = $event.val"></ibex-checkbox>
      <div class="finish-container" *ngIf="!dynamicContent.content.finished">
        <button (click)="finishVoting()" mat-button>{{ 'dynamicContent.finishVoting' | translate }}</button>
      </div>
      <div class="finish-container" *ngIf="dynamicContent.content.finished">
        <div>{{ 'dynamicContent.votingFinished' | translate }}
          <span
            *ngIf="dynamicContent.content.publishEndResult">{{ 'dynamicContent.resultAvailable' | translate }} {{ dynamicContent.content.publishEndResultMoment | date : 'dd.MM.YYYY' }}</span>
        </div>
      </div>
    </div>
  </form>
</mat-card>

<data-table (remove)="removeGroup($event)" *ngIf="!!tableData" [columns]="columns" [hideSearch]="true" [headerButtons]="headerButtons"
            [plainData]="tableData" [title]="'myUsers.groupAssignment' | translate" [newHeader]="true"></data-table>
